import { render, staticRenderFns } from "./AddImportPage.vue?vue&type=template&id=813ad668"
import script from "./AddImportPage.vue?vue&type=script&lang=js"
export * from "./AddImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports